/**
 * 数值类型筛选器默认值配置
 * - 用于数值字段（通过字符串筛选器 + isNumeric 标记识别）
 */

import React from 'react';
import { Form } from 'tea-component';
import { useIntl } from 'umi';
import NumberFilter from '@/pages/datalab/components/DashboardLayout/components/TopFilters/GeneralFilterGroup/NumberFilter';
import { Operation } from '@dbl/core/filter';
import type { IFilterState, INumberDefaultValue } from '../../types';

interface IFilterNumberDefaultValueProps {
  state: IFilterState;
  dispatch: React.Dispatch<any>;
}

const FilterNumberDefaultValue: React.FC<IFilterNumberDefaultValueProps> = ({
  state,
  dispatch,
}) => {
  const { formatMessage } = useIntl();

  const numberDefaultValue = state.defaultValue as INumberDefaultValue | undefined;

  // 处理数值筛选器变更
  const handleNumberFilterChange = (value: { value?: number[]; operation?: string; }): void => {
    dispatch({
      type: 'SET_DEFAULT_VALUE',
      payload: {
        operation: value.operation || 'gt',
        value: value.value || [],
      },
    });
  };

  return (
    <Form.Item
      className="dbl-edit-filter-selector"
      label={formatMessage({ id: 'dbl_create_dashboard_default_value' })}
      showStatusIcon={false}
      status={state.validation.defaultValueError ? 'error' : undefined}
      message={
        state.validation.defaultValueError === 'error'
          ? formatMessage({ id: 'dbl_common_cannot_be_empty' })
          : state.validation.defaultValueError || ''
      }
    >
      <NumberFilter
        filterInfo={{
          otherInfo: state.columnInfo || {},
        }}
        value={{
          value: numberDefaultValue?.value || [],
          operation: numberDefaultValue?.operation || Operation.Greater,
        }}
        onChange={({ value, operation }) => {
          handleNumberFilterChange({
            value: value || [],
            operation: operation || Operation.Greater,
          });
        }}
      />
    </Form.Item>
  );
};

export default FilterNumberDefaultValue;



